import React, { useState, useEffect, useContext } from 'react'
import { Table } from 'react-bootstrap-v5';
import { Form, Modal } from 'react-bootstrap';
import DataTable from '../components/DataTable';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Swal from 'sweetalert2'
import GetPagePermission from '../components/GetPagePermission';
import { AppContext } from '../context/AppContext';

interface Item {
    idItems: number;
    itemName: string;
    itemCode: string;
    categoryName: string;
    unitName: string;
}

interface ProductCostSummary {
    idProducts: number;
    productName: string;
    alternateName: string;
    itemCode: string;
    size: number;
    packing: string;
    unitName: string;
    itemUnitName: string;
    itemCost: number;
    overheadCost: number;
    vat: number;
    weightedLoss: number;
    totalCost: number;
}

interface ProductCostItemRow {
    idProductCostItems: number | null;
    idItems: number | null;
    itemName: string;
    categoryName: string;
    quantity: number;
    rate: number;
    amount: number;
    unitName?: string;
}

export default function Products() {

    const { currentUser } = useContext(AppContext);
    const showBomExport = Number(currentUser?.id) === 3;

    const jwt = () => {
        const myToken = localStorage.getItem('MyToken');
        return myToken != null ? JSON.parse(myToken) : '';
    };

    const hasProductStatusPermission = GetPagePermission("/product-status-change");
    const hasProductFormulationPermission = GetPagePermission("/product-formulation-view");
    const [items, setItems] = useState<Item[]>([]);
    const [tableGlobalSearch, setTableGlobalSearch] = useState('');
    const [newData, setNewData] = useState<any>({});

    const [projects, setProjects] = useState<any[]>([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [showInactiveProducts, setShowInactiveProducts] = useState(false);
    const [showFormulationModal, setShowFormulationModal] = useState(false);
    const [selectedAlternateForFormulation, setSelectedAlternateForFormulation] = useState<any | null>(null);
    const [selectedBomForFormulation, setSelectedBomForFormulation] = useState<any | null>(null);
    const [formulationSummary, setFormulationSummary] = useState<ProductCostSummary | null>(null);
    const [formulationItems, setFormulationItems] = useState<ProductCostItemRow[]>([]);
    const [formulationLoading, setFormulationLoading] = useState(false);

    useEffect(() => {
        getAllProjects();
        getItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reloadTable = () => setNewData({ id: Date.now() });

    const getAllProjects = async () => {

        const url = process.env.REACT_APP_API_URL + 'projects';
        const response = await fetch(url, getRequestOptions());
        const data = await response.json();

        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setProjects(data.data)

        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setProjects(allProjects);
        }

    }

    const handleProjectChange = (selectedProject: any) => {
        setProject(selectedProject);
    }

    const handleShowInactiveProductsChange = (checked: boolean) => {
        setShowInactiveProducts(checked);
    }

    const getItems = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'production-items?idProjects=' + ((project === null) ? '' : project.value),
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                let items = resp.data.map((item: any) => {
                    return item
                });
                setItems(items);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const parseBomList = (bomList: string | null) => {
        if (!bomList) {
            return [];
        }
        return bomList.split('|').map((entry) => {
            const [id, ...nameParts] = entry.split(':');
            return {
                id_product_boms: Number(id),
                idProductBoms: Number(id),
                bom_name: nameParts.join(':'),
                bomName: nameParts.join(':'),
            };
        }).filter((bom) => bom.id_product_boms && bom.bom_name);
    };

    const getBomId = (bom: any) => bom.id_product_boms ?? bom.idProductBoms;

    const getBomName = (bom: any) => bom.bom_name ?? bom.bomName ?? 'BOM';

    const openFormulationModal = (row: any, bom?: any) => {
        const alternate = row.rowType === 'alternate'
            ? { name: row.displayName, id_product_group_alternate_names: row.idAlternateNames }
            : null;

        setSelectedAlternateForFormulation(alternate);
        setSelectedBomForFormulation(bom || null);
        setShowFormulationModal(true);

        const productId = row.idProducts;
        const bomId = bom ? getBomId(bom) : null;
        if (!productId || !bomId) {
            setFormulationSummary(null);
            setFormulationItems([]);
            return;
        }

        setFormulationLoading(true);
        fetch(
            process.env.REACT_APP_API_URL + 'products/' + productId + '?id_product_bom=' + bomId,
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                const data = resp.data || {};
                const summary: ProductCostSummary = {
                    idProducts: data.idProducts,
                    productName: data.productName,
                    alternateName: data.alternateName,
                    itemCode: data.itemCode,
                    size: parseFloat(data.size),
                    packing: data.packing,
                    unitName: data.unitName,
                    itemUnitName: data.itemUnitName,
                    itemCost: parseFloat(data.itemCost),
                    overheadCost: parseFloat(data.overheadCost),
                    vat: parseFloat(data.vat),
                    weightedLoss: parseFloat(data.weightedLoss),
                    totalCost: parseFloat(data.totalCost),
                };
                setFormulationSummary(summary);

                const items: ProductCostItemRow[] = (resp.items || []).map((item: any) => ({
                    ...item,
                    rate: parseFloat(item.rate),
                    quantity: parseFloat(item.quantity),
                    amount: parseFloat(item.amount),
                }));
                setFormulationItems(items);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop');
                setFormulationSummary(null);
                setFormulationItems([]);
            })
            .finally(() => {
                setFormulationLoading(false);
            });
    };

    const closeFormulationModal = () => {
        setShowFormulationModal(false);
        setSelectedAlternateForFormulation(null);
        setSelectedBomForFormulation(null);
        setFormulationSummary(null);
        setFormulationItems([]);
        setFormulationLoading(false);
    };

    const confirmStatusProduct = async (idProducts: number, status: string) => {
        var msgTxt1 = status === 'Inactive' ? 'INACTIVE' : 'ACTIVE'
        var msgTxt2 = status === 'Inactive' ? 'Deactivate' : 'Activate'
        const confirm = await Swal.fire({
            title: 'Are you sure to proceed?',
            text: "This will mark this product as " + msgTxt1,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, ' + msgTxt2 + ' it!',
        })
        if (confirm.value) {
            const requestOptions = postRequestOptions()
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}confirmStatusProduct/${idProducts}/${status}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    reloadTable();
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'Could not update product status.',
                    })
                }
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Could not update product status.',
                })
            }
        }
    }

    const confirmStatusAlternateName = async (idAlternateNames: number, status: string) => {
        var msgTxt1 = status === 'Inactive' ? 'INACTIVE' : 'ACTIVE'
        var msgTxt2 = status === 'Inactive' ? 'Deactivate' : 'Activate'
        const confirm = await Swal.fire({
            title: 'Are you sure to proceed?',
            text: "This will mark this alternate name as " + msgTxt1,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, ' + msgTxt2 + ' it!',
        })
        if (confirm.value) {
            const requestOptions = postRequestOptions()
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}productGroupAlternateNameStatus/${idAlternateNames}/${status}`,
                    requestOptions
                )
                let respData = await response.json()
                if (respData.success === true) {
                    reloadTable();
                    const successMsg = respData.successMessage
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: 'Could not update alternate name status.',
                    })
                }
            } catch (error) {
                console.log(error, 'catch the hoop')
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Could not update alternate name status.',
                })
            }
        }
    }

    useEffect(() => {
        if (projects.length === 1) {
            setProject({ label: projects[0]['label'], value: projects[0]['value'] })
        }
    }, [projects])

    const renderStatusCell = (row: any) => {
        if (row.rowType === 'alternate') {
            return (
                <>
                    {row.idAlternateNames && row.status === 'Active' &&
                        <span onClick={() => confirmStatusAlternateName(row.idAlternateNames, 'Inactive')} className="btn btn-success btn-sm" style={{ cursor: 'pointer' }}>Active</span>
                    }
                    {row.idAlternateNames && row.status === 'Inactive' &&
                        <span onClick={() => confirmStatusAlternateName(row.idAlternateNames, 'Active')} className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}>Inactive</span>
                    }
                    {row.idAlternateNames && (!row.status || (row.status !== 'Active' && row.status !== 'Inactive')) &&
                        <span onClick={() => confirmStatusAlternateName(row.idAlternateNames, 'Active')} className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>Set Status</span>
                    }
                </>
            );
        }

        return (
            <>
                {row.idProducts !== undefined && row.status === 'Active' &&
                    <span onClick={() => confirmStatusProduct(row.idProducts, 'Inactive')} className="btn btn-success btn-sm" style={{ cursor: 'pointer' }}>Active</span>
                }
                {row.idProducts !== undefined && row.status === 'Inactive' &&
                    <span onClick={() => confirmStatusProduct(row.idProducts, 'Active')} className="btn btn-danger btn-sm" style={{ cursor: 'pointer' }}>Inactive</span>
                }
                {row.idProducts !== undefined && (!row.status || (row.status !== 'Active' && row.status !== 'Inactive')) &&
                    <span onClick={() => confirmStatusProduct(row.idProducts, 'Active')} className="btn btn-secondary btn-sm" style={{ cursor: 'pointer' }}>Set Status</span>
                }
            </>
        );
    };

    const renderFormulationCell = (row: any) => {
        const boms = parseBomList(row.bomList);
        if (boms.length === 0) {
            return <span className="text-muted">-</span>;
        }

        return (
            <div>
                {boms.map((bom: any, bomIndex: number) => (
                    <React.Fragment key={getBomId(bom)}>
                        {bomIndex > 0 && <hr className="my-1" />}
                        <button
                            type="button"
                            className="btn btn-link btn-sm p-0"
                            onClick={() => openFormulationModal(row, bom)}
                        >
                            {getBomName(bom)}
                        </button>
                    </React.Fragment>
                ))}
            </div>
        );
    };

    const columns = [
        { value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
        {
            value: 'displayName',
            title: 'Product Name',
            style: { textAlign: 'left' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => {
                const isInactive = row.status === 'Inactive';
                const isAlternate = row.rowType === 'alternate';
                return (
                    <span
                        className={isAlternate ? 'ps-5' : ''}
                        style={{
                            padding: isAlternate ? '0 3px' : undefined,
                            fontSize: isAlternate ? '10px' : 'inherit',
                            ...(isInactive ? { backgroundColor: '#FAA0A0' } : {}),
                        }}
                    >
                        {row.displayName}
                    </span>
                );
            },
        },
        ...(hasProductStatusPermission ? [{
            value: 'status',
            title: 'Status',
            style: { textAlign: 'center' },
            hasActionsComponent: true,
            actionsComponent: renderStatusCell,
        }] : []),
        ...(hasProductFormulationPermission ? [{
            value: 'formulation',
            title: 'Formulation',
            style: { textAlign: 'center' },
            hasActionsComponent: true,
            actionsComponent: renderFormulationCell,
        }] : []),
        {
            value: 'packing',
            title: 'Packing',
            style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => `${row.packing} ${row.groupUnitName || ''}`.trim(),
        },
        {
            value: 'size',
            title: 'Size',
            style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => `${row.size} ${row.groupUnitName || ''}`.trim(),
        },
        {
            value: 'salePerUnit',
            title: 'Sale/Unit',
            style: { textAlign: 'right' },
            hasHtmlComponent: true,
            htmlComponent: (row: any) => Number(row.salePerUnit).toLocaleString('en-US', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }),
        },
        { value: 'unitName', title: 'Unit', style: { textAlign: 'right' } },
    ];

    const filters = columns.reduce((acc: Record<string, { filterType: string; filterValue: string }>, column) => {
        if (column.value !== 'action') {
            acc[column.value] = { filterType: 'like', filterValue: '' };
        }
        return acc;
    }, {});

    const additionalPostData = {
        idProjects: project?.value ?? '',
        showInactive: showInactiveProducts,
    };

    const url = process.env.REACT_APP_API_URL + 'productsViewList';

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header card-header-stretch overflow-auto d-flex flex-wrap align-items-center justify-content-between gap-3'>
                    <div className='card-title mb-0'>
                        <h3 className='card-label'>All Product List</h3>
                    </div>
                    <div className='card-toolbar d-flex flex-wrap gap-2 align-items-center'>
                        <a
                            target='_blank'
                            rel='noreferrer'
                            className='btn btn-sm btn-primary'
                            href={`${process.env.REACT_APP_BACKEND}productExport?export=true&idProjects=${project?.value ?? ''}&showOnlyWithStock=false&showOnlyWithCostSetup=false&sortBySize=false&searchProduct=${encodeURIComponent(tableGlobalSearch)}&token=${jwt()}`}
                        >
                            <i className='fas fa-download me-1' /> Export
                        </a>
                        {showBomExport ? (
                            <a
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-sm btn-primary'
                                href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&token=${jwt()}`}
                            >
                                <i className='fas fa-download me-1' /> BOM Export
                            </a>
                        ) : null}
                        {showBomExport ? (
                            <a
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-sm btn-primary'
                                href={`${process.env.REACT_APP_BACKEND}bomExport?export=true&idProjects=${project?.value ?? ''}&status=showAll&type=Active&token=${jwt()}`}
                            >
                                <i className='fas fa-download me-1' /> Active BOM Export
                            </a>
                        ) : null}
                    </div>
                </div>
                <div className="card-body">

                    <Tabs
                        defaultActiveKey="product"
                        id="uncontrolled-tab-example"
                        className="mb-3 ml-3 mr-3"
                    >
                        <Tab eventKey="product" title="Product">

                            <div className="form-group row">
                                <label htmlFor="project" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Project</label>
                                <div className="col-lg-5">
                                    <Select
                                        value={project}
                                        onChange={handleProjectChange}
                                        options={projects}
                                        menuPosition="fixed"
                                        placeholder={project.label}
                                    />
                                </div>
                                <div className="col-md-3" style={{ marginTop: "-10px" }}>
                                    <Form.Group controlId="showInactiveProducts">
                                        <Form.Label></Form.Label>
                                        <Form.Check
                                            type="switch"
                                            id="show-inactive-products-switch"
                                            label="Show Inactive Products/Alternate Names"
                                            className="form-switch"
                                            checked={showInactiveProducts}
                                            onChange={(e) => handleShowInactiveProductsChange(e.target.checked)}
                                        />
                                    </Form.Group>
                                </div>
                            </div>

                            <div className='mt-6'>
                                <DataTable
                                    key={`${hasProductStatusPermission}-${hasProductFormulationPermission}`}
                                    url={url}
                                    columns={columns}
                                    filters={filters}
                                    newData={newData}
                                    additionalPostData={additionalPostData}
                                    defaultSortedColumn="categoryName"
                                    onValueChange={(state: any) => setTableGlobalSearch(state.globalSearch || '')}
                                />
                            </div>

                        </Tab>
                        <Tab eventKey="item" title="Item">

                            <Table size='sm' striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: '25%' }}>Item Name</th>
                                        <th className='text-center' style={{ width: '25%' }}>Item Code</th>
                                        <th className='text-center' style={{ width: '25%' }}>Item Category</th>
                                        <th className='text-center' style={{ width: '25%' }}>Unit</th>
                                    </tr>
                                </thead>

                                {items?.map((item, itemIndex) => (
                                    <tbody key={itemIndex}>
                                        <tr>
                                            <td>{item.itemName}</td>
                                            <td className='text-center'>{item.itemCode}</td>
                                            <td className='text-center'>{item.categoryName}</td>
                                            <td className='text-center'>{item.unitName}</td>
                                        </tr>
                                    </tbody>
                                ))}
                            </Table>
                        </Tab>


                    </Tabs>
                </div>

                {hasProductFormulationPermission && (
                    <Modal show={showFormulationModal} onHide={closeFormulationModal} size="lg" centered>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                Product Formulation
                                {selectedBomForFormulation && ` - ${getBomName(selectedBomForFormulation)}`}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {formulationLoading && (
                                <p>Loading formulation...</p>
                            )}
                            {!formulationLoading && formulationSummary && (
                                <>
                                    <Table size='sm' bordered hover>
                                        <tbody>
                                            <tr>
                                                <td width={'30%'}>Product Name</td>
                                                <td width={'70%'}> : {formulationSummary.productName}</td>
                                            </tr>
                                            <tr>
                                                <td>Alternate Name</td>
                                                <td>
                                                    : {formulationSummary.alternateName}
                                                    {selectedAlternateForFormulation && selectedAlternateForFormulation.name &&
                                                        ` (Clicked: ${selectedAlternateForFormulation.name})`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Product Code</td>
                                                <td> : {formulationSummary.itemCode}</td>
                                            </tr>
                                            <tr>
                                                <td>Size</td>
                                                <td> : {formulationSummary.size + ' ' + formulationSummary.itemUnitName}</td>
                                            </tr>
                                            <tr>
                                                <td>Pack</td>
                                                <td> : {formulationSummary.packing + ' ' + formulationSummary.itemUnitName}</td>
                                            </tr>
                                            <tr>
                                                <td>Unit</td>
                                                <td> : {formulationSummary.unitName}</td>
                                            </tr>
                                        </tbody>
                                    </Table>

                                    <Table size='sm' bordered hover>
                                        <thead>
                                            <tr>
                                                <th className="col-3">Item</th>
                                                <th className="col-2">Category</th>
                                                <th className="col-2">Quantity</th>
                                                <th className="col-1">Unit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formulationItems
                                                .filter((productItem) => Number(productItem.quantity) !== 0)
                                                .map((productItem, index) => (
                                                <tr key={'item' + index}>
                                                    <td className='text-left'>{productItem.itemName}</td>
                                                    <td>{productItem.categoryName}</td>
                                                    <td className='text-end'>{productItem.quantity}</td>
                                                    <td>{productItem.unitName}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </>
                            )}
                            {!formulationLoading && !formulationSummary && (
                                <p>No formulation data found for this product.</p>
                            )}
                        </Modal.Body>
                    </Modal>
                )}

            </div>

        </>
    )
}
